import Link from 'next/link';
import { SOCIAL_NAVIGATION_LINKS } from '@/constants/socials';

export const SocialLinks = () => (
  <div className="flex flex-row gap-x-4">
    {SOCIAL_NAVIGATION_LINKS.map(({ href, icon: Icon, name }) => (
      <Link
        className="text-gray-400 hover:text-gray-500"
        href={href}
        key={href}
        target="_blank"
      >
        <span className="sr-only">{name}</span>
        <Icon
          aria-hidden="true"
          className="size-7"
          desc={`${name} social media icon`}
          title={name}
        />
      </Link>
    ))}
  </div>
);
